import { action } from 'src/store/actions';

/* Customer Documents */
export const FETCH_CUSTOMER_DOCUMENTS = 'FETCH_CUSTOMER_DOCUMENTS';
export const REQUEST_CUSTOMER_DOCUMENTS = 'REQUEST_CUSTOMER_DOCUMENTS';
export const SUCCESS_CUSTOMER_DOCUMENTS = 'SUCCESS_CUSTOMER_DOCUMENTS';
export const FAILURE_CUSTOMER_DOCUMENTS = 'FAILURE_CUSTOMER_DOCUMENTS';

export const fetchCustomerDocuments = () => action(FETCH_CUSTOMER_DOCUMENTS);
export const requestCustomerDocuments = () => action(REQUEST_CUSTOMER_DOCUMENTS);
export const requestCustomerDocumentsSuccess = (response: any) => action(SUCCESS_CUSTOMER_DOCUMENTS, { response });
export const requestCustomerDocumentsFailure = (error: any) => action(FAILURE_CUSTOMER_DOCUMENTS, { error });
